// Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createNewUser, setNewUserGroups } from '../state/manageuser/actions';
import { getListUsers, redirectToEdit, redirectToAccessLog,
	redirectToCreate, deleteUser, setCurrentPage, setSearchTerms } from '../state/gerenciarUsuarios/actions';

// Components
import GerenciarUsurios from '../components/ManageUser/GerenciarUsurios';

function mapStateToProps(state) {
	return {
		isFetching: state.lUsers.isFetching,
		users: state.lUsers,
		isAdminPlus: state.login.isAdminPlus
	};
}

function mapDispatchToProps(dispatch) {
	return {
		createNewUser: bindActionCreators(createNewUser, dispatch),
		setNewUserGroups: bindActionCreators(setNewUserGroups, dispatch),
		getListUsers: bindActionCreators(getListUsers, dispatch),
		redirectToEdit: bindActionCreators(redirectToEdit, dispatch),
		redirectToCreate: bindActionCreators(redirectToCreate, dispatch),
		redirectToAccessLog: bindActionCreators(redirectToAccessLog, dispatch),
		deleteUser: bindActionCreators(deleteUser, dispatch),
		setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
		setSearchTerms: bindActionCreators(setSearchTerms, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(GerenciarUsurios);


// WEBPACK FOOTER //
// ./src/containers/GerenciarUsuariosContainer.js